export enum QMSModifyType {
    SetAsPrinted = 1,
    Deactivate = 2,
}